import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()

export class UserService {

	public baseUrl: string; 

	constructor(private _http: Http) {
		this.baseUrl = environment.apiUrl;
	}

	getlist(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'user-auth?page=' + data.page + '&limit=' + data.limit, { headers: headers })
			.map(res => res.json());
	}

	newuser(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'user-auth', json, { headers: headers })
			.map(res => res.json());
	}

	getuser(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'user-auth/' + data.id, { headers: headers })
			.map(res => res.json());
	}

	deleteuser(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.delete(this.baseUrl + 'user-auth/' + data.id, { headers: headers })
			.map(res => res.json());
	}

	edituser(data: any) {

		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		delete data.auth_token;
		let json = JSON.stringify(data);

		return this._http.put(this.baseUrl + 'user-auth/' + data.id, json, { headers: headers })
			.map(res => res.json());
	}

	saveUserSchedule(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		delete data.auth_token;
		let json = JSON.stringify(data);

		return this._http.post(this.baseUrl + 'save-user-schedule', json, { headers: headers })
			.map(res => res.json());
	}

	updateUserSchedule(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		let json = JSON.stringify(data);
		return this._http.put(this.baseUrl + 'user-schedule/' + data.user_schedule_id, json ,{ headers: headers })
			.map(res => res.json());
	}


	deleteUserSchedule(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.delete(this.baseUrl + 'user-schedule/' + data.id, { headers: headers })
			.map(res => res.json());
	}

	deleteLoteUserSchedule(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		delete data.auth_token;
		let json = JSON.stringify(data);

		return this._http.post(this.baseUrl + 'delete-all', data, { headers: headers })
			.map(res => res.json());
	}


	resetpass(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'user/password-reset', json, { headers: headers })
			.map(res => res.json());
	}

	getShop(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'user/shop', json, { headers: headers })
			.map(res => res.json());
	}

	getStatusPending(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'user/get-status-pending', json, { headers: headers })
			.map(res => res.json());
	}

	getStatusConetion(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'user/status-contetion', json, { headers: headers })
			.map(res => res.json());
	}


	getSchedule(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'schedule/' + data.id, { headers: headers })
			.map(res => res.json());
	}

	getScheduleList(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'schedule?page=' + data.page + '&limit=' + data.limit, { headers: headers })
			.map(res => res.json());
	}

	getScheduleListByType(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token); 

		return this._http.post(this.baseUrl + 'schedule-by-type', data, { headers: headers })
			.map(res => res.json());
	}

	uploadfiles(data: any) {
		let json = JSON.stringify(data);
		const formData = new FormData();
		formData.append('image', data.file); 
		const headers = new Headers({});
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		return this._http.post(this.baseUrl + 'user-auth/' + data.user_id + '/update-image-profile', formData, { headers: headers })
			.map(res => res.json());
	}

	public getListAgents(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		headers.append('Access-Control-Allow-Origin', '*');
		return this._http.get(this.baseUrl + 'list-agent', { headers: headers }).map(res => res.json());
	}

	public getListAgentsByStatus(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		headers.append('Access-Control-Allow-Origin', '*');
		return this._http.post(this.baseUrl + 'list-agent', json, { headers: headers }).map(res => res.json());
	}

	public getAllAgents(data: any) { 
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		headers.append('Access-Control-Allow-Origin', '*');
		//return this._http.get(this.baseUrl + 'all-agent/', { headers: headers }).map(res => res.json());
		return this._http.get(this.baseUrl + 'all-agent', { headers: headers }).map(res => res.json());
	}

	public getAllAgentsInReport(data: any) { 
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		headers.append('Access-Control-Allow-Origin', '*');
		//return this._http.get(this.baseUrl + 'all-agent/', { headers: headers }).map(res => res.json());
		return this._http.post(this.baseUrl + 'all-agent-in-report', data, { headers: headers }).map(res => res.json());
	}

	public getAgents(data: any) { 
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'get-agents', data, { headers: headers }).map(res => res.json());
	}

	public newAssignment(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		//console.log(data.auth_token);
		//console.log("Esto es lo que se le envía al servidor: ", json);
		return this._http.post(this.baseUrl + 'newAssignment', data, { headers: headers }).map(res => res.json());
	}

	public newAssignmentAll(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		//console.log(data.auth_token);
		//console.log("Esto es lo que se le envía al servidor: ", json);
		return this._http.post(this.baseUrl + 'newAssignmentAll', data, { headers: headers }).map(res => res.json());
	}
	
	public updatePreviousUserId(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		//console.log(data.auth_token);
		//console.log("Esto es lo que se le envía al servidor: ", json);
		return this._http.post(this.baseUrl + 'updatePreviousUserId', data, { headers: headers }).map(res => res.json());
	}
	//Prueba

	public getPreviousUser(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		//console.log(data.auth_token);
		//console.log("Esto es lo que se le envía al servidor: ", json);
		return this._http.post(this.baseUrl + 'getPreviousUser', data, { headers: headers }).map(res => res.json());
	}

	exportAsExcelFile(json: any[], excelFileName: string): void {
    
	const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
	const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
	const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
	//const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
	this.saveAsExcelFile(excelBuffer, excelFileName);
	}

	saveAsExcelFile(buffer: any, fileName: string): void {
	const data: Blob = new Blob([buffer], {
		type: EXCEL_TYPE
	});
	FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
	}

	public getInfoRooms(data: any) { 
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'get-info-rooms', data, { headers: headers }).map(res => res.json());
	}

	public getInfoComments(data: any) { 
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'get-info-comments', data, { headers: headers }).map(res => res.json());
	}

	public getRoomsPending(data: any) { 
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'getRoosmPending', data, { headers: headers }).map(res => res.json());
	}

	public getRoomMsgsPending(data: any) { 
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'getRoomMsgsPending', data, { headers: headers }).map(res => res.json());
	}

	public getVariablesPending(data: any) { 
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'getVariablesPending', data, { headers: headers }).map(res => res.json());
	}

    public getVariablesRooms(data: any) { 
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'getVariablesRooms', data, { headers: headers }).map(res => res.json());
	}
	

	public getReportDataWait(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		return this._http.post(this.baseUrl + 'reportWait', json, {headers: headers}).map(res => res.json());
	}

	getRoomMsgs(data: any) {   
		let json = JSON.stringify(data.user_id);
		let user_id = data.user_id != null ? '?user_id='+data.user_id : '';
		let headers = new Headers();
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');
		return this._http.get(this.baseUrl + 'room/' + data.room_id + '/messages'+ user_id, {headers: headers}).map(res => res.json());
	}

	changeRoomStatusAll(data: any) {  
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
	
		return this._http.post(this.baseUrl + 'room/status-change', json, { headers: headers }).map(res => res.json());
	}

    public getTemplatesRooms(data: any) {
        let json = JSON.stringify(data);
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + data.auth_token);

        return this._http.post(this.baseUrl + 'get-templates-rooms', json, { headers: headers }).map(res => res.json());
    }

    getTemplateId(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'get-templates-id', json, { headers: headers })
			.map(res => res.json());
	}


    getTemplateVariables(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'get-templates-variables', json, { headers: headers })
			.map(res => res.json());
	}

    sendPush(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'send-push', json, { headers: headers })
			.map(res => res.json());
	}

    getUsersPending(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'usersPending?page=' + data.page + '&limit=' + data.limit, { headers: headers })
			.map(res => res.json());
	}

    sendPushUserPending(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'send-push-pending', json, { headers: headers })
			.map(res => res.json());
	}

    public getRoomsArchived(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		return this._http.post(this.baseUrl + 'report/rooms-archived', json, {headers: headers}).map(res => res.json());
	}

    getReportData(data: any) {
        let json = JSON.stringify(data);
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + data.auth_token);
        return this._http.post(this.baseUrl + 'report', json, {headers: headers}).map(res => res.json());
    }

    getIds(data:any){ 
        let json = JSON.stringify(data);
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + data.auth_token);
        return this._http.post(this.baseUrl + 'getData', json, {headers: headers}).map(res => res.json());
	}

	getTimeZoneList(data:any){ 
        let json = JSON.stringify(data);
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + data.auth_token);
        return this._http.post(this.baseUrl + 'timeZoneList', json, {headers: headers}).map(res => res.json());
	}

	refreshRooms(data:any){
		let json = JSON.stringify(data);
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + data.auth_token);
        return this._http.post(this.baseUrl + 'room/refreshRooms', json, {headers: headers}).map(res => res.json());
	}

	
}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend/src/app/admin/user/user.service.ts